import dayjs from './dayjs'
import { DATE_TIME_FORMAT, TORONTO_TIMEZONE } from '@/constants/time'

export const formatDateWithTimezone = (
  date: Date,
  timezone = TORONTO_TIMEZONE,
) => {
  return dayjs.utc(date).tz(timezone).format(DATE_TIME_FORMAT)
}

export const localDate = (timezone = TORONTO_TIMEZONE) => {
  return dayjs.utc().tz(timezone)
}

export const dateInToronto = (date?: string | Date) => {
  return date
    ? dayjs.utc(date).tz(TORONTO_TIMEZONE)
    : dayjs.utc().tz(TORONTO_TIMEZONE)
}

export const dayjsToTime = (
  d: dayjs.Dayjs,
): { hour: number; minute: number; second: number } => {
  return {
    hour: d.hour(),
    minute: d.minute(),
    second: d.second(),
  }
}

export const timeToDayjs = (t: {
  hour: number
  minute: number
  second: number
}): dayjs.Dayjs => {
  return dateInToronto()
    .set('hour', t.hour)
    .set('minute', t.minute)
    .set('second', t.second)
}

export const formatDate = (
  date: Date | string,
  format: string = 'DD-MM-YYYY',
): string => {
  return dateInToronto(date).format(format)
}

export const transformDateToTimezone = (date: string | Date): string => {
  if (!date) return ''

  // If it's already a string, return it
  if (typeof date === 'string') return date

  // If it's a Date object, convert it to Toronto timezone with proper offset
  if (typeof date === 'object') {
    // Use dayjs to format with timezone offset
    return dateInToronto(date).format()
  }

  return date
}

/**
 * Parse a YYYY-MM-DD string as a local date (no timezone conversion)
 * This avoids UTC midnight conversion issues
 */
export const parseLocalDateString = (dateString: string): Date | undefined => {
  if (!dateString) return undefined

  // Split YYYY-MM-DD and create date in local timezone
  const [year, month, day] = dateString.split('-').map(Number)

  if (!year || !month || !day) return undefined

  // Create date at noon to avoid DST issues
  return new Date(year, month - 1, day, 12, 0, 0)
}

/**
 * Convert a Date object to YYYY-MM-DD string in local timezone
 */
export const toLocalDateString = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
